import { fetchOrganizerById, fetchOrganizerOwnEventsPublic } from "@/apiEndpoints";
import EventCard from "@/components/EventCard";
import NoEvent from "@/icons/EmptyState/NoEvent";
import { Spinner } from "@heroui/react";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export default function IframeEvents() {

    const { id } = useParams();

    const { data: hostArr, isLoading: isHostLoading } = useQuery({
        queryKey: ['host', id],
        queryFn: () => fetchOrganizerById(id as string),
        enabled: !!id,
    });
    const host = Array.isArray(hostArr) ? hostArr[0] : hostArr;

    const { data: events = [], isLoading: isEventsLoading } = useQuery({
        queryKey: ['events', id],
        queryFn: () => fetchOrganizerOwnEventsPublic(id as string),
        enabled: !!id,
    });

    // Simulate follow mutation (TODO: replace with real API)


    // Filter events by isPast (if available)
    const filteredEvents = Array.isArray(events?.data)
        ? events?.data
        : [];
    return (
        <div className="container max-w-screen-2xl py-4 mx-auto px-2 w-full min-h-screen flex flex-col bg-[#fff]" style={{ overscrollBehavior: 'none' }}>

            <main className="flex-1 min-w-0">
                {isEventsLoading ? (

                    <>
                        <div className="w-full flex justify-center items-center py-12 text-gray-400 text-lg"><Spinner /></div>
                    </>
                ) : (
                    <>
                        {filteredEvents.length > 0 ?
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                                <>
                                    {filteredEvents.map((event: any, i: number) => (
                                        <EventCard key={i} event={event} iframe={true} userInfo={null} organizerInfo={host} />
                                    ))}
                                </>
                            </div>
                            :
                            <div className='flex flex-col items-center justify-center h-[400px]'>
                                <NoEvent />
                                <span>There is no event</span>
                            </div>
                        }
                    </>
                )}
            </main>

        </div>
    );
}